import { axiosNT, axiosNTL } from '../../../services/axios';
import { UserBody } from '../types/UsersBody';
import _ from 'lodash';

const usersList = () => {
    return axiosNT.get('/user/usersLastActivity')
        .then((res: any) => {
            let users: UserBody[] = res.responseObject;
            return Promise.resolve(users);
        });
}


const myReviewees = () => {
    return axiosNT.get('/user/revieweesLastActivity?showLastActivity=true')
        .then((res: any) => {
            let usersReviewees: UserBody[] = res.responseObject;
            return Promise.resolve(usersReviewees);
        });
}

const getContentCount = (contentType: string, days: number) => {
    return axiosNTL.get(`/dashboard/${contentType}/${days}`)
        .then((res: any) => {
            let count: number = res.responseObject;
            return Promise.resolve(count);
        })
}

const getMentionOfYou = () =>{
    return axiosNTL.get('/dashboard/getMentionsOfYou')
    .then((res: any)=>{
        let resObj = !_.isEmpty(res.responseObject) && res.statusCode == 200 ? res.responseObject : []; 
        return Promise.resolve(resObj);
    })
}

const getRecentComments = () =>{
    return axiosNTL.get('/dashboard/getRecentComments')
    .then((res: any)=>{
        let resObj = !_.isEmpty(res.responseObject) && res.statusCode == 200 ? res.responseObject : []; 
        return Promise.resolve(resObj);
    })
}

const getMyCourses = () =>{
    return axiosNTL.get('/dashboard/getMyCourses')
    .then((res: any)=>{
        let resObj = !_.isEmpty(res.responseObject) && res.statusCode == 200 ? res.responseObject : []; 
        return Promise.resolve(resObj);
    })
}

export const dashboardService = {
    usersList,
    myReviewees,
    getContentCount,
    getMentionOfYou,
    getRecentComments,
    getMyCourses,
}